import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { User } from '../types';
import './users-table.css';
import { TableHeader } from '../../common';
interface UsersTableProps {
  users: User[];
  loading: boolean;
  onEdit: (user: User) => void;
  onDelete: (id: number) => Promise<boolean>;
  onCreate: () => void;
}

const UsersTable: React.FC<UsersTableProps> = ({ 
  users, 
  loading, 
  onEdit, 
  onDelete, 
  onCreate 
}) => {
  // Estado para el filtro global
  const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
  const [filters, setFilters] = useState({
    global: { value: null as string | null, matchMode: FilterMatchMode.CONTAINS }
  });

  // Manejar cambio en el input de búsqueda
  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  // Función para confirmar eliminación
  const confirmDeleteUser = (user: User) => {
    confirmDialog({
      message: `¿Estás seguro de eliminar al usuario ${user.email}?`,
      header: 'Confirmar Eliminación',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sí, eliminar',
      rejectLabel: 'No, cancelar',
      acceptClassName: 'p-button-danger',
      accept: () => onDelete(user.id)
    });
  };

  // Template para la columna de acciones
  const actionTemplate = (rowData: User) => {
    return (
      <div className="action-buttons">
        <Button 
          icon="pi pi-pencil" 
          className="p-button-rounded p-button-text p-button-success mr-2" 
          onClick={() => onEdit(rowData)} 
          tooltip="Editar" 
        />
        <Button 
          icon="pi pi-trash" 
          className="p-button-rounded p-button-text p-button-danger" 
          onClick={() => confirmDeleteUser(rowData)} 
          tooltip="Eliminar" 
        />
      </div>
    );
  };

  const header = <TableHeader 
    globalFilterValue={globalFilterValue} 
    onGlobalFilterChange={onGlobalFilterChange} 
    buttonText="Crear Usuario"
    onButtonClick={onCreate}
  />;

  return (
    <div className="users-table-container">
      <DataTable
        value={users}
        paginator
        rows={20}
        rowsPerPageOptions={[20, 50, 100, 200]}
        tableStyle={{ minWidth: '50rem' }}
        loading={loading}
        filters={filters}
        globalFilterFields={['id', 'email', 'role']} 
        header={header}
        emptyMessage="No se encontraron usuarios"
        size="small"
        stripedRows
        pt={{
          table: { style: { fontSize: '0.875rem' } }
        }}
      >
        <Column field="id" header="ID" sortable style={{ width: '10%' }} />
        <Column field="email" header="Email" sortable style={{ width: '40%' }} />
        <Column field="role" header="Rol" sortable style={{ width: '20%' }} />
        <Column body={actionTemplate} header="Acciones" style={{ width: '20%', textAlign: 'center' }} />
      </DataTable>
    </div>
  );
};

export default UsersTable; 